import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../../Navbar";
import Sidebar from "../../../Sidebar";
import { CDBTable, CDBTableHeader, CDBTableBody, CDBSpinner } from "cdbreact";
import AdicionarDespesaModal from "./AdicionarDespesaModal";
import {
  deleteExpenseById,
  listAllExpensesByPage,
} from "../../../services/ExpenseService";
import currencyBRFormat from "../../../util/CurrencyUtils";
import EditarDespesaModal from "./EditarDespesa";
import { toast } from "react-toastify";
import PaginationBootstrap from "../../../components/PaginationBootstrap";
import ReactDatePicker from "react-datepicker";
import isAuthorized from "../../../util/RoleUtil";
const dayjs = require("dayjs");

export const Despesas = () => {
  const [expenses, setExpenses] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageInfo, setPageInfo] = useState();
  const [toggled, setToggled] = useState(false);
  const date = new Date();
  const defaultStartDate = new Date(date.getFullYear(), date.getMonth(), 1);
  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(
    new Date(
      defaultStartDate.getFullYear(),
      defaultStartDate.getMonth(),
      dayjs(defaultStartDate).daysInMonth()
    )
  );
  const bottomRef = useRef(null);
  let isMobile = window.innerWidth <= 720;

  useEffect(() => {
    window.scrollTo(0, 0);
    handleSidebarToggle();
    listExpenses();
  }, []);

  function handleSearchFilters() {
    listExpenses();
    scrollToBottom();
  }

  function handleUpdatePaidExpensa() {
    const action = window.confirm(
      `Tem certeza que deseja atualizar todas as contas de ${dayjs(
        startDate
      ).format("DD/MM/YYYY")} até ${dayjs(startDate).format(
        "DD/MM/YYYY"
      )} para pagas?`
    );
  }

  function handleClearFilters() {
    setStartDate(new Date());
    setEndDate(new Date());
    listExpenses();
  }

  const scrollToBottom = () => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  function listExpenses() {
    setIsLoading(true);
    const filter = {
      startDate: dayjs(startDate).format("YYYY-MM-DD"),
      endDate: dayjs(endDate).format("YYYY-MM-DD"),
    };
    listAllExpensesByPage(null, filter)
      .then((response) => {
        setExpenses(response.data);
        setPageInfo(response.pageInfo);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("[despesas] listExpenses", error);
      });
  }

  function listExpensesByPage(page) {
    setIsLoading(true);
    const filter = {
      startDate: dayjs(startDate).format("YYYY-MM-DD"),
      endDate: dayjs(endDate).format("YYYY-MM-DD"),
    };
    listAllExpensesByPage(page, filter)
      .then((response) => {
        const data = response.data;
        setExpenses(data);
        setPageInfo(response.pageInfo);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("[despesas] listExpensesByPage", error);
      });
  }

  function deleteExpense(expense) {
    const executeAction = window.confirm(
      `Confirma a exclusão irreversível da despesa\n ${expense.description}?`
    );

    if (executeAction) {
      deleteExpenseById(expense.id)
        .then((response) => {
          toast.success(response);
          listExpenses(false);
        })
        .catch((error) => toast.error(error));
    }
  }

  function handleSidebarToggle() {
    if (isMobile) {
      setToggled(true);
    }
  }

  return (
    <div className="d-flex">
      <div>
        <Sidebar toggled={toggled} />
      </div>
      <div
        className="main-content-wrapper"
      >
        <Navbar toggled={toggled} setToggled={setToggled} />
        <div>
          <div
            style={{
              padding: "20px 5%",
            }}
          >
            <div>
              <div className="mt-3 w-100 d-flex">
                <h3 className="fw-bold text-dark">Despesas</h3>
              </div>

              <>
                <div className="d-flex mt-3 mb-3">
                  <div>
                    <AdicionarDespesaModal listExpenses={listExpenses} />
                  </div>

                  <div className="vertical-line"></div>

                  <div>
                    <button
                      className="btn"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseExample"
                      aria-expanded="false"
                      aria-controls="collapseExample"
                    >
                      <i className="fa fa-filter me-2"></i>
                      Filtrar
                    </button>
                  </div>
                </div>

                <div className="mt-3 mb-3">
                  <div className="collapse" id="collapseExample">
                    <div className="card card-body">
                      <div>
                        <div className="row">
                          <div className="col-lg-2">
                            <div className="mb-2">
                              <label>Data inicial</label>
                            </div>
                            <ReactDatePicker
                              className="form-control"
                              dateFormat="dd/MM/yyyy"
                              locale="pt-BR"
                              selected={startDate}
                              todayButton="Hoje"
                              onMonthChange={(data) => setStartDate(data)}
                              onChange={(date) => setStartDate(date)}
                            />
                          </div>

                          <div className="col-lg-2">
                            <div className="mb-2 mt-lg-0 mt-3">
                              <label>Data final</label>
                            </div>

                            <ReactDatePicker
                              className="form-control"
                              dateFormat="dd/MM/yyyy"
                              locale="pt-BR"
                              selected={endDate}
                              todayButton="Hoje"
                              onMonthChange={(data) => setEndDate(data)}
                              onChange={(date) => setEndDate(date)}
                            />
                          </div>

                          <div className="mt-3">
                            <button
                              onClick={handleSearchFilters}
                              className="btn btn-sm btn-primary"
                              disabled={!startDate || !endDate}
                            >
                              {" "}
                              <i
                                className="fa fa-search me-2"
                                aria-hidden="true"
                              ></i>
                              Pesquisar
                            </button>
                            <button
                              onClick={handleUpdatePaidExpensa}
                              className="d-none btn btn-sm btn-primary mx-3"
                              disabled={!startDate || !endDate}
                              title="Esse botão atualiza todas as despesas do período filtrado para pagas"
                            >
                              <i
                                className="fa fa-check me-2"
                                aria-hidden="true"
                              ></i>
                              Atualizar pagas
                            </button>
                            <button
                              onClick={handleClearFilters}
                              className="d-none btn mt-lg-0 mt-md-0 mt-3 mx-2"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseExample"
                            >
                              <i className="fa fa-times me-2"></i>
                              Limpar filtros
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>

              {isLoading ? (
                <div className="d-flex justify-content-center p-3">
                  <CDBSpinner dark />
                </div>
              ) : (
                <>
                  <CDBTable className="alcon-table" responsiveSm borderless>
                    <thead>
                      <tr>
                        <th>Vencimento</th> {/* Renomeado de Data */}
                        <th>Descrição</th>
                        <th>Valor</th>
                        <th className="text-center">Status</th>
                        <th className="text-center">Lembrete</th> {/* Nome reduzido */}
                        <th className="text-end px-4">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {expenses && expenses.map((expense) => (
                        <tr key={expense.id}>
                          {/* Vencimento - Data de quando a conta deve ser paga */}
                          <td className="fw-medium text-muted small">
                            {dayjs(expense.createdAt).format("DD/MM/YYYY")}
                          </td>

                          {/* Descrição principal */}
                          <td className="fw-bold text-dark">{expense.description}</td>

                          {/* Valor em destaque */}
                          <td className="fw-bold text-danger">
                            {currencyBRFormat(expense.value)}
                          </td>

                          {/* Status de Pagamento (Paga/Pendente) */}
                          <td className="text-center">
                            <span className={`badge rounded-pill ${expense.paid ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'}`} style={{ fontSize: '0.75rem' }}>
                              {expense.paid ? "PAGA" : "PENDENTE"}
                            </span>
                          </td>

                          {/* Lembrete de Vencimento (Apenas ícone para economizar espaço) */}
                          <td className="text-center">
                            {expense.notifyDueDate ? (
                              <i className="fas fa-bell text-warning" title="Lembrete ativo"></i>
                            ) : (
                              <i className="fas fa-bell-slash text-light opacity-50" title="Sem lembrete"></i>
                            )}
                          </td>

                          {/* Ações com seu botão .btn-3-dots */}
                          <td className="text-end px-3">
                            {isAuthorized(["ROLE_OWNER"]) && (
                              <div className="dropdown">
                                <button
                                  className="btn btn-link btn-3-dots text-muted shadow-none p-0"
                                  type="button"
                                  data-bs-toggle="dropdown"
                                  data-bs-display="static"
                                >
                                  <i className="fas fa-ellipsis-v"></i>
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end shadow-lg border-0 rounded-3">
                                  <li>
                                    <EditarDespesaModal
                                      expense={expense}
                                      listExpenses={listExpenses}
                                    />
                                  </li>
                                  <li><hr className="dropdown-divider" /></li>
                                  <li>
                                    <button
                                      onClick={() => deleteExpense(expense)}
                                      className="dropdown-item py-2 d-flex align-items-center text-danger"
                                    >
                                      Excluir Registro
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </CDBTable>
                  <div ref={bottomRef}>
                    {expenses.length > 0 ? (
                      <div>
                        <div className="d-flex justify-content-end">
                          <label>Total em despesas</label>
                          <div className="mx-2 ">
                            {expenses &&
                              currencyBRFormat(
                                expenses
                                  .map((exp) => exp.value)
                                  .reduce(
                                    (a, b) => parseFloat(a) + parseFloat(b),
                                    0
                                  )
                              )}
                          </div>
                        </div>
                        <PaginationBootstrap
                          pageInfo={pageInfo}
                          goToPage={listExpensesByPage}
                        />
                      </div>
                    ) : (
                      <>Nenhuma despesa encontrada nesse período</>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Despesas;
